mp.content = {
    nanobar: null,

    init: function () {
        mp.content.nanobar = new Nanobar({
            classname: 'mpNanobar'
        });

        if (window.location.search.match(/tab=rent/)) {
            $('#mpOfferTabNavRent').trigger('click');
        }

        $(document).on('click', '#mpContent .mpXhrTabs .nav-link,#mpContent .mpXhrlink', mp.content.href);
        $(document).on('submit', '#mpContent form.mpContentXhr', mp.content.formSubmit);
        $(document).on('change', '#mpContent select.mpContentXhr,#mpContent input[type="checkbox"].mpContentXhr,#mpContent input[type="radio"].mpContentXhr', mp.content.fieldTrigger);
        $(document).on('keyup', '#mpContent input.mpContentXhr', function (ev) {
            // keine Cursor-Keys
            if (ev.keyCode == 9 || ev.keyCode == 16 || ev.keyCode == 17 || ev.keyCode == 18 ||
                ev.keyCode == 37 || ev.keyCode == 38 || ev.keyCode == 39 || ev.keyCode == 40 ||
                ev.keyCode == 91 || ev.keyCode == 20 || ev.keyCode == 224
            ) {
                return;
            }
            //console.log(ev.keyCode);
            mp.content.fieldTrigger(ev);
        });

        // links in Modal
        $(document).on('click', '.mpLoadIntoModal', mp.content.loadIntoModal);

        $('#mpAlternateLangSrc a').on('click', mp.content.showAlternateLangDescription);

        // wenn das mpGenericModal modifiziert wurde (u.a. mp.googlemap.loadModalMap oder auch via mp.form.loadIntoModal)
        $('#mpGenericModal').on('hidden.bs.modal', mp.content.resetModal);

        // nachträglicher DOM-Aufbau
        $(document).on('show.bs.modal', '.mpSearchModal', mp.content.updateModalBody);
    },

    resetModal: function (ev) {
        $('#mpGenericModal .modal-dialog,#mpGenericModal .modal-content,#mpGenericModal .modal-body').removeClass('h-100 modal-fixed');
        $('#mpGenericModal .modal-title').html('');
        $('#mpGenericModal .modal-body').html('');
        $('#mpGenericModal .modal-footer').html('').hide();
    },

    loadIntoModal: function (ev) {
        ev.preventDefault();

        var ref = $(this);
        mp.analytics.loadPage(ref.attr('href'));
        $('#mpGenericModal .modal-body').load(ref.attr('href'), function () {
            if (typeof (ref.attr('title')) !== 'undefined' && ref.attr('title') !== '') {
                $('#mpGenericModal .modal-title').html(ref.attr('title'));
            } else if (ref.text() !== '') {
                $('#mpGenericModal .modal-title').html(ref.text());
            }
            $('#mpGenericModal').modal('show');
            try {
                observerLozad.observe();
            } catch (e) {
            }

            $('#mpEvent').trigger('contentxhr');
        });

        return false;
    },

    href: function (ev) {
        ev.preventDefault();
        $(ev.target).tooltip('hide');
        mp.content.nanobar.go(23);

        var preventScroll = false;
        if (typeof ($(ev.target).data('prevent-scroll')) !== 'undefined') {
            preventScroll = true;
        }

        var keepSearchModal = false;
        if ($('#mpSearchModal').is(':visible')) {
            keepSearchModal = $('#mpSearchModal .modal-body').scrollTop();
            preventScroll = true;
        }

        mp.content.load($(ev.currentTarget).attr('href'), preventScroll, keepSearchModal);

        return false;
    },

    formSubmit: function (ev) {
        ev.preventDefault();
        mp.content.nanobar.go(23);

        var preventScroll = false;
        if (typeof ($(ev.target).data('prevent-scroll')) !== 'undefined') {
            preventScroll = true;
        }

        var keepSearchModal = false;
        if ($('#mpSearchModal').is(':visible')) {
            keepSearchModal = $('#mpSearchModal .modal-body').scrollTop();
            preventScroll = true;
        }

        var form = $(ev.target);
        var formValues = mp.content.getCleanFormValues(form);
        mp.content.load(form.attr('action') + '?' + $.param(formValues), preventScroll, keepSearchModal);

        return false;
    },

    fieldTrigger: function (ev) {
        ev.preventDefault();
        $(ev.target).tooltip('hide');
        mp.content.nanobar.go(23);

        var parentForm = $(ev.target).parents('form');

        // FIXME: durch das reset-values ersetzen!
        if (typeof ($(ev.target).data('reset-field')) !== 'undefined') {
            $($(ev.target).data('reset-field')).val(null);
        }

        var resetValues = '';
        if (typeof ($(ev.target).data('reset-values')) !== 'undefined') {
            resetValues = $(ev.target).data('reset-values');
        }

        var preventScroll = false;
        if (typeof ($(ev.target).data('prevent-scroll')) !== 'undefined') {
            preventScroll = true;
        }

        var keepSearchModal = false;
        if ($('#mpSearchModal').is(':visible')) {
            keepSearchModal = $('#mpSearchModal .modal-body').scrollTop();
            preventScroll = true;
        }

        var formValues = mp.content.getCleanFormValues(parentForm, resetValues);
        if (parentForm.data('content-method') === 'post') {
            var action = parentForm.attr('action');
            if (parentForm.data('content-action') != null) {
                action = parentForm.data('content-action');
            }
            if (mp.search.p == null) {
                mp.content.loadWithPost(action, formValues, $(ev.target).attr('id'));
            } else if (mp.search.p.validate()) {
                mp.content.loadWithPost(action, formValues, $(ev.target).attr('id'));
            } else {
                mp.content.nanobar.go(0);
            }
        } else {
            mp.content.load(parentForm.attr('action') + '?' + $.param(formValues), preventScroll, keepSearchModal);
        }

        return false;
    },

    load: function (url, preventScroll, keepSearchModal) {
        if (keepSearchModal === false) {
            $('.modal').modal('hide');
        }

        $('#mpContent').load(url, function (data, state, meta) {
            try {
                observerLozad.observe();
                observerLozadAds.observe();
                observerLozadAdsDetail.observe();
                mp.select2.lazyLoadSelect2();
            } catch (e) {
            }
            try {
                mp.currencyswitch.recalculatePrices();
                mp.tooltip.init();

                $('input[name="currentPage"]').val(document.location.origin + url);
                // FIXME: der Title bei replaceState wird vom Firefox aktuell ignoriert (Stand Ende 2018)
                // FIXME: statt replaceState wäre pushState eigentlich cooler - bedeutet aber einiges an weiteren Ergänzungen
                if (typeof (meta.getResponseHeader('X-Title')) === 'string') {
                    $('title').html($.parseJSON(meta.getResponseHeader('X-Title'))); // ist eh besser den direkt zu ändern
                    window.history.replaceState({}, meta.getResponseHeader('X-Title'), url);
                } else {
                    window.history.replaceState({}, document.title, url);
                }
                mp.analytics.loadPage(url);

                if (preventScroll === false) {
                    if ($('h1').length == 0) {
                        $(window).scrollTo(0, 300); // trifft für Micropages zu
                    } else {
                        $(window).scrollTo('h1', 300);
                    }
                }

                $('#mpEvent').trigger('contentxhr');
                mp.content.nanobar.go(100);

                if (keepSearchModal !== false) {
                    $('.modal-backdrop.show').remove();
                    mp.search.mobileFilter();
                    $('#mpSearchModal .modal-body').scrollTop(keepSearchModal);
                }
            } catch (e) {
                console.log(e);
            }
        });
    },

    loadWithPost: function (url, params, targetId) {
        $('.modal').modal('hide');

        // FIXME: Abort-Handling
        $.post(url, params, function (data, state, meta) {
            if (parseInt(meta.getResponseHeader('X-Resultcount')) > 0) {
                $('#mpContent').html(data);
                try {
                    observerLozad.observe();
                    observerLozadAds.observe();
                    observerLozadAdsDetail.observe();
                    mp.select2.lazyLoadSelect2();
                } catch (e) {
                }
                try {
                    mp.currencyswitch.recalculatePrices();

                    if (targetId != null) {
                        $('#' + targetId).focus();
                    }

                    if ($('#mpSearchForm').length === 1) {
                        // FIXME: bedarf noch einer Überarbeitung
                        mp.search.p = $('#mpSearchForm').parsley();
                        mp.search.p.validate();
                        //$('#mpSearchForm input[type="text"]').trigger('keyup');

                        Cookies.set('MP_Search', params, {
                            expires: 30,
                            path: '/',
                            domain: '.' + document.location.hostname,
                            secure: (location.protocol === 'https:'),
                            samesite: (location.protocol === 'https:' ? 'None' : 'Lax')
                        });
                    }

                    $('#mpEvent').trigger('contentxhr');
                    mp.content.nanobar.go(100);
                } catch (e) {
                    console.log(e);
                }
            } else {
                mp.content.nanobar.go(100);
                $('#mpSearchNoResults').show();
            }
        });
    },

    showAlternateLangDescription: function (ev) {
        ev.preventDefault();
        var ref = $(this);
        $('#mpAlternateLangOut')
            .prop('dir', ref.data('dir'))
            .html(ref.data('description'));

        return false;
    },

    getCleanFormValues: function (form, resetValues) {
        if (typeof (resetValues) === 'undefined') {
            resetValues = [];
        } else {
            try {
                resetValues = resetValues.split(',');
            } catch (e) {
                resetValues = [];
            }
        }

        var values = form.serializeArray();
        var uniqValues = {};
        var newValues = [];
        var i;

        for (i in values) {
            // checkboxen in Login-Offerlist
            if (!values[i].name.match(/^multiaction/)) {
                uniqValues[values[i].name] = values[i].value;
            }
        }
        //console.log(values); console.log(uniqValues);
        for (i in uniqValues) {
            if (uniqValues[i] !== '' && $.inArray(i, resetValues) === -1) {
                newValues.push({name: i, value: uniqValues[i]});
            }
        }
        newValues.sort(mp.content.compareName);

        return newValues;
    },

    compareName: function (a, b) {
        // alternative: return a.name.localeCompare(b.name)
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        return 0;
    },

    niceUrl: function (ref, params) {
        $(ref).attr('href', $(ref).attr('href') + params);
    },

    updateModalBody: function (ev) {
        var mBody = $(ev.currentTarget).find('.modal-body');
        console.log(mBody.find('.mpFilterListData').length);
        if (mBody.find('.mpFilterListData').length === 1) {
            mBody.find('.mpFilterList').html($.parseJSON(mBody.find('.mpFilterListData').text()));
            mBody.find('.mpFilterListData').remove();
        }
    }

};

$(document).ready(function () {
    mp.content.init();
});



